import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const IsUserExist = (loginId, tenantName) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.LOGIN.IS_USER_EXISTS(loginId, tenantName)
  );
};

export default IsUserExist;
